// extracted by mini-css-extract-plugin
export default {"button":"SaveButton_button__utzBt","icon":"SaveButton_icon__b-fx3"};